import React from 'react'
import {FormattedMessage} from 'react-intl'
import styled from '@emotion/styled'
import {Hotel} from '@findhotel/sapi'
import {PriceComponent} from 'components/Offer/Compact/PriceComponent'
import {useOtaMode} from 'hooks/useOtaMode'
import {SearchOffer} from 'modules/sapiSearch/slice'

import {Box} from '@vio/atlas/helpers/Box'
import {Text} from '@vio/atlas/src/components/designSystem/Text'
import {cssTheme} from '@vio/atlas/src/themes'
import minus from '@vio/atlas/src/utils/minus'
import {ProviderLogo} from '@vio/shared/src/search/ProviderLogo'

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: ${cssTheme.layout.spacing.s200};
  flex-wrap: wrap;
  row-gap: ${cssTheme.layout.spacing.s000};
  column-gap: ${cssTheme.layout.spacing.s100};
  padding-right: ${cssTheme.layout.spacing.s100};
  margin-right: ${cssTheme.layout.spacing.s100};
`

const IconWrapper = styled.div`
  position: relative;
  border: 1px solid ${cssTheme.colors.neutral.c000};
  border-radius: ${cssTheme.layout.radius.rounded};
  margin-left: ${minus(cssTheme.layout.spacing.s200)};
  :nth-of-type(1) {
    z-index: 3;
  }
  :nth-of-type(2) {
    z-index: 2;
  }
  :nth-of-type(3) {
    z-index: 1;
  }
`

const StyledText = styled(Text)`
  white-space: nowrap;
`

const MainWrapper = styled.div`
  .--text-lg-bold {
    ${cssTheme.typography.bodyXS}
  }
`

interface Props {
  hotelId: Hotel['objectID']
  cheapestOfferFromOthers: SearchOffer
  otherOffersMetadata: {
    providerCode: string
    brandInfo: SearchOffer['metadata']['brandInfo']
  }[]
}
export const OtherSites: React.FC<Props> = ({
  hotelId,
  cheapestOfferFromOthers,
  otherOffersMetadata
}) => {
  const {isOTAMode} = useOtaMode()

  if (isOTAMode) {
    return null
  }

  return (
    <Wrapper>
      <Box display="flex" gap="s200" alignItems="center">
        <Box display="flex" flexDirection="row-reverse">
          {otherOffersMetadata.map(({providerCode, brandInfo}) => (
            <IconWrapper key={providerCode}>
              <ProviderLogo
                providerCode={providerCode}
                brandInfo={brandInfo}
                variant="circle"
                height={16}
              />
            </IconWrapper>
          ))}
        </Box>
        <StyledText variant="bodyXS">
          <FormattedMessage
            id="otherSitesPrice"
            defaultMessage="Other sites:"
          />
        </StyledText>
      </Box>
      <MainWrapper>
        <PriceComponent
          variant="CompactDefault"
          isSplitBooking={false}
          hotelId={hotelId}
          showAnchorPrice={false}
          anchorPrice={cheapestOfferFromOthers?.nightlyRate}
          anchorPriceTotal={cheapestOfferFromOthers?.totalRate}
          offer={cheapestOfferFromOthers}
        />
      </MainWrapper>
    </Wrapper>
  )
}
